import { useEffect, useState } from "react";
import Button from "../../../../button/button";
import Select from "../../../../select/select";
import { GetPaymentPlans, PatchChangePaymentPlanStudent } from "../../../../../utils/Apis/receptionApis";

const ChangePaymentPlan = ({ onClose, student, paymentPlan, planUpdated,setPlanUpdated, showAlert }) => {
    const [pplans, setPPlans] = useState([]);
    const [filteredPPlans, setFilteredPPlans] = useState([]);
    const [selectedMode, setSelectedMode] = useState('');
    const [selectedPlan, setSelectedPlan] = useState('');
    const [studentId, setStudentId]= useState(null)
    const modeOptions = [
        { value: 0, label: "Presencial" },
        { value: 1, label: "Online" },
    ];
    const [disabledButton, setDisabledButton]= useState(false)

    /* ---------------------------------------------------
       1️⃣ Cargar planes de pago
    --------------------------------------------------- */
    useEffect(() => {
        const fetchData = async () => {
            try {
                const paymentPlans = await GetPaymentPlans();

                if (paymentPlans.status === 200) {
                    const formatted = paymentPlans.result.map(v => ({
                        value: v.id,
                        label: `${v.year} - $${v.tuition_normal} / $${v.tuition_prompt} / $${v.tuition_late} - ${v.exist_discount === 1 ? 'Con descuento' : 'Sin descuento'}`,
                        exist_discount: v.exist_discount,
                        is_online: v.is_online,
                    }));
                    setStudentId(student.id_student)
                    setPPlans(formatted);
                }
            } catch (error) {
                console.error("Error obteniendo planes:", error);
            }
        };

        fetchData();
    }, []);

    /* ---------------------------------------------------
       2️⃣ Autoseleccionar modalidad y plan actual
           (cuando ya existen los planes)
    --------------------------------------------------- */
    useEffect(() => {
        if (!pplans.length || !paymentPlan) return;

        const mode = Number(paymentPlan.is_online);
        setSelectedMode(mode);

        const filtered = pplans.filter(
            p => Number(p.is_online) === mode
        );

        setFilteredPPlans(filtered);
        setSelectedPlan(paymentPlan.id);
    }, [pplans, paymentPlan]);

    /* ---------------------------------------------------
       3️⃣ Handlers
    --------------------------------------------------- */
    const handleSelectedMode = (mode) => {
        const parsedMode = Number(mode);
        setSelectedMode(parsedMode);
        setSelectedPlan('');

        const filtered = pplans.filter(
            p => Number(p.is_online) === parsedMode
        );

        setFilteredPPlans(filtered);
    };

    const handleSelectedPlan = (plan) => {
        setSelectedPlan(Number(plan));
    };

    const handleConfirmChangePaymentPlan = async() =>{
        setDisabledButton(true)
        try {
                const paymentPlanChange = await PatchChangePaymentPlanStudent(selectedPlan,studentId);
                if (paymentPlanChange.status === 200) {
                    setPlanUpdated(!planUpdated)
                    showAlert('success',paymentPlanChange.message)
                    setTimeout(() => {
                        onClose()
                    }, 1500);
                }else{
                    showAlert('danger',paymentPlanChange.message)
                    setDisabledButton(false)
                }
            } catch (error) {
                console.error(error);
            }
    }

    return (
        <div className="change-payment-plan-contain">
            <h1 className="title-1">Cambiar plan de pago</h1>
            <h1 className="title-2">Selecciona modalidad y plan de pago</h1>

            <Select
                value={selectedMode}
                onChange={(e)=>handleSelectedMode(e.target.value)}
                options={modeOptions}
                placeholder="Modalidad"
                className="main-color"
            />

            <Select
                value={selectedPlan}
                onChange={(e)=>handleSelectedPlan(e.target.value)}
                options={filteredPPlans}
                placeholder="Normal / Puntual / Atrasado"
                className="main-color"
                disabled={selectedMode=== null}
            />

            <div className="confirm-buttons-section">
                <Button
                    text="Cancelar"
                    backgroundColor="red"
                    onClick={onClose}
                    disabled={disabledButton}
                />
                <Button
                    text="Confirmar"
                    disabled={selectedMode === null || selectedPlan === '' || disabledButton}
                    onClick={handleConfirmChangePaymentPlan}
                />
            </div>
        </div>
    );
};

export default ChangePaymentPlan;